import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { ApiService } from '../../../../../utility/api.service'
import { ToastCtl } from '../../../../components/custom/toast/ToastCtl'

export const fetchAppointments = createAsyncThunk('appointments/fetchAll', async (_, { rejectWithValue }) => {
    const response = await ApiService.get(`${process.env.REACT_APP_ASSETENERGY_APP_API}/assetapp/appointments`)
    if (!response.success) {
        return rejectWithValue(response.exception)
    }

    return { appointments: Object.values(response.data) }
})

export const fetchAppointment = createAsyncThunk('appointment/fetch', async ({ id }, { rejectWithValue }) => {
    const response = await ApiService.get(`${process.env.REACT_APP_ASSETENERGY_APP_API}/assetapp/appointment/${id}`)
    if (!response.success) {
        return rejectWithValue(response.exception)
    }

    return { appointment: response.data.appointment }
})

export const updateAppointment = createAsyncThunk('appointment/update', async ({ id, payload }, { rejectWithValue }) => {
    const response = await ApiService.patch(`${process.env.REACT_APP_ASSETENERGY_APP_API}/assetapp/appointment/${id}`, payload)
    if (!response.success) {
        return rejectWithValue(response.exception)
    }

    return { appointment: response.data.appointment }
})

const initialState = {
    appointments: [],
    selectedAppointment: null,
    loading: false,
    submitting: false,
    error: null
}

const appointmentSlice = createSlice({
    name: 'appointments',
    initialState,
    reducers: {
        // standard reducer logic, with auto-generated action types per reducer
    },
    extraReducers: {
        [fetchAppointments.pending]: (state) => {
            state.loading = true
        },
        [fetchAppointments.fulfilled]: (state, { payload }) => {
            state.appointments = payload.appointments
            state.loading = false
        },
        [fetchAppointments.rejected]: (state, action) => {
            state.loading = false
            state.error = action
        },

        [fetchAppointment.pending]: (state) => {
            state.loading = true
        },
        [fetchAppointment.fulfilled]: (state, { payload }) => {
            state.selectedAppointment = payload.appointment
            state.loading = false
        },
        [fetchAppointment.rejected]: (state, action) => {
            state.loading = false
            state.error = action
        },

        [updateAppointment.pending]: (state) => {
            state.submitting = true
        },
        [updateAppointment.fulfilled]: (state, { payload }) => {
            state.selectedAppointment = payload.appointment
            state.submitting = false

            ToastCtl.success('Daten wurden erfolgreich gespeichert')
        },
        [updateAppointment.rejected]: (state, action) => {
            state.submitting = false
            // NO error state because we show toast directly

            ToastCtl.error('Daten konnten nicht gespeichert werden')
        }
    }
})

export default appointmentSlice.reducer